import React from 'react'
import type { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { Tooltip } from '@material-ui/core'

import { mixpanelTrack } from '@homeviews/seo'
import { Button } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      height: '23px',
      marginLeft: '8px',
      paddingRight: '15px',
      paddingLeft: '15px',
      border: '1px solid #DEE1E6',
      borderRadius: '11.5px',
      letterSpacing: '-0.23px',
      color: theme.colors.grey800,
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: theme.colors.grey250,
      },
      '&.MuiButtonBase-root.Mui-disabled': {
        opacity: 0.5,
      },
    },
  }),
)

type GoToButtonProps = {
  href: string
  trackingEventName: string
  isDisabled?: boolean
}

export const GoToButton: FC<GoToButtonProps> = ({
  href,
  trackingEventName,
  isDisabled,
}) => {
  const classes = useStyles()
  const history = useHistory()

  const BaseButton = () => (
    <Button
      className={classes.button}
      onClick={() => {
        history.push(href)
        mixpanelTrack(trackingEventName, { Href: href })
      }}
      disabled={isDisabled}
    >
      Go to
    </Button>
  )

  // Wrap in Tooltip if isDisabled
  if (isDisabled) {
    return (
      <Tooltip
        disableFocusListener
        disableTouchListener
        title="You do not have permission to use this feature. Please contact your account manager."
      >
        <span>
          <BaseButton />
        </span>
      </Tooltip>
    )
  } else {
    return <BaseButton />
  }
}
